import React, { FC } from 'react';
import { FooterContainer } from '../styled/containers/FooterContainer';

const Footer: FC = () => {
  return <FooterContainer>©{new Date().getFullYear()} CAS.</FooterContainer>;
};

export default Footer;
